<template>
  <page-layout>
    <base-row v-if="isTokenFetched" class="iframe-height">
      <base-col class="h-100">
        <iframe
          :src="birdigoCreateSegmentUrl"
          width="100%"
          height="100%"
          style="border: none"
        />
      </base-col>
    </base-row>
    <base-row
      v-else
      style="align-items: center"
      justify="center"
      class="h-screen"
      no-gutters
    >
      <base-col cols="auto">
        <base-progress-circular
          indeterminate
          color="primary"
          class="profile__selection__loading"
          :width="100"
          :size="100"
        />
      </base-col>
    </base-row>
  </page-layout>
</template>

<script lang="ts" setup>
  import PageLayout from '@/layouts/PageLayout.vue'
  import {
    BaseRow,
    BaseCol,
    BaseProgressCircular
  } from '@deltax/vuetify-wrapper-components'
  import { ref, onMounted, computed } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useNotificationStore } from '@/store/notification'
  import { useI18n } from 'vue-i18n'
  import { useTheme } from 'vuetify/lib/framework.mjs'
  import useAudienceStore from '@/store/audience'

  const audienceStore = useAudienceStore()
  const route = useRoute()
  const router = useRouter()
  const notification = useNotificationStore()
  const { t } = useI18n()
  const vuetifyTheme = useTheme()

  const token = ref('')
  const isTokenFetched = ref(false)
  let leadXOrganizationId = ''

  onMounted(async () => {
    if (!audienceStore.leadXOrganizationId) {
      await audienceStore.fetchAndsetLeadXOrganizationId()
    }
    if (!audienceStore.leadXEmbedToken) {
      await audienceStore.fetchAndSetLeadXEmbedToken()
    }
    token.value = audienceStore.leadXEmbedToken
    leadXOrganizationId = audienceStore.leadXOrganizationId
    isTokenFetched.value = true

    window.addEventListener('message', event => {
      const message = event.data
      if (message.type === 'messageFromBirdigo') {
        if (message.data?.status == 'segmentCreatedSuccessfully') {
          notification.notify(
            t('messages.CustomerSegmentCreatedSuccessMessage'),
            'success'
          )
          // make the recipe details null, so that the recipes details fetch again
          audienceStore.resetRecipeDetails()
        } else if (message.data?.status == 'segmentUpdateSuccessfully') {
          notification.notify(
            t('messages.CustomerSegmentUpdatedSuccessMessage'),
            'success'
          )
        } else if (message.data?.status == 'error') {
          notification.notify(t('errors.somethingWentWrong'), 'error')
        }
        router.push({ name: 'audience' })
      }
    })
  })

  const birdigoCreateSegmentUrl = computed(() => {
    const isDarkTheme = vuetifyTheme.global.name.value === 'light'
    let primaryColor, secondaryColor, backgroundColor
    if (isDarkTheme) {
      primaryColor = vuetifyTheme.themes.value.dark.colors.primary.substring(1)
      secondaryColor =
        vuetifyTheme.themes.value.dark.colors.secondary.substring(1)
      backgroundColor =
        vuetifyTheme.themes.value.dark.colors.background.substring(1)
    } else {
      primaryColor = vuetifyTheme.themes.value.light.colors.primary.substring(1)
      secondaryColor =
        vuetifyTheme.themes.value.light.colors.secondary.substring(1)
      backgroundColor =
        vuetifyTheme.themes.value.light.colors.surface.substring(1)
    }

    let url = `${import.meta.env.VITE_APP_BIRDIGO_UI_URL}/embed/organizations/${leadXOrganizationId}/audience/segments/create?token=${encodeURIComponent(token.value)}&primary=${primaryColor}&secondary=${secondaryColor}&isDarkTheme=${isDarkTheme}&background=${backgroundColor}`
    if (route.query.segmentTemplateId) {
      url += `&segmentTemplateId=${route.query.segmentTemplateId}`
    }
    if (route.query.enableUploadCsv === 'true') {
      url += `&enableUploadCsv=true`
    }
    if (route.query.segmentName) {
      url += `&segmentName=${route.query.segmentName}`
    }

    return url
  })
</script>

<style>
  ::v-deep(.ps__rail-y){
    display: none;
}

.iframe-height
{
  height: 91vh;
}
</style>
